export * from './AttendeeDescription';
export * from './CoorganizerDescription';
export * from './PanelistDescription';
export * from './RegistrantDescription';
export * from './SessionDescription';
export * from './WebinarDescription';
